import React from "react";

import familieLerchAsset from "@/assets/intro/Familie_Lerch_HWM_3.webp.asset.json";
const familieLerch = familieLerchAsset.url;
import bildmarkeBg from "@/assets/icons/Bildmarke_background_hellgrau.svg";
import Reveal from "@/components/Reveal";
import { useLocale } from "@/contexts/LocaleContext";
import { EditableT, EditableImage } from "@/cms/EditableT";

const IntroSection: React.FC = () => {
  const { t } = useLocale();
  const paragraphs = [t("home.intro.p1"), t("home.intro.p2"), t("home.intro.p3")];
  const headline = t("home.intro.headline");
  const splitIdx = headline.toLowerCase().lastIndexOf(" in ");
  const headlineFirst = splitIdx > 0 ? headline.slice(0, splitIdx) : headline;
  const headlineSecond = splitIdx > 0 ? headline.slice(splitIdx + 1) : "";

  return (
    <section
      aria-label="Einleitung"
      className="relative w-full bg-white text-[#383637] overflow-hidden"
    >
      <div className="relative z-10 mx-auto max-w-[1560px] px-6 md:px-10 lg:px-16 py-16 md:py-24 lg:py-32">
        <img
          src={bildmarkeBg}
          alt=""
          aria-hidden="true"
          className="pointer-events-none select-none absolute z-0 w-[520px] h-[467px] opacity-50 hidden lg:block"
          style={{ top: "460px", left: "-220px" }} width={1600} height={1067} loading="lazy" decoding="async"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text column */}
          <Reveal as="article" className="flex flex-col gap-[35px] max-w-[704px]">
            <header className="flex flex-col gap-[35px]">
              <span className="block t-subline text-[#383637] whitespace-pre-line">
                <EditableT k="home.intro.subline" multiline />
              </span>
              <h1 className="t-headline text-[#383637] [@media(min-width:1500px)]:whitespace-nowrap">
                <EditableT k="home.intro.headline" multiline />
              </h1>
            </header>
            <div className="flex flex-col gap-6">
              {([
                "home.intro.p1",
                "home.intro.p2",
                "home.intro.p3",
              ] as const).map((key) => (
                <p key={key} className="t-body text-[#383637]">
                  <EditableT k={key} multiline html />
                </p>
              ))}
            </div>
          </Reveal>

          {/* Image column – <lg quadratisch */}
          <Reveal delay={150} className="relative w-full">
            <EditableImage
              id="home.intro.image"
              src={familieLerch}
              alt={t("home.intro.image_alt")}
              className="w-full h-auto object-cover object-[50%_15%] aspect-square lg:aspect-[635/713] max-h-[713px]"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
